import { Outlet } from 'react-router-dom';
import usePageViewAnalytics from 'analytics/usePageViewAnalytics';

const Analytics = () => {
    usePageViewAnalytics();

    return <Outlet />;
};

export default Analytics;
